export default __webpack_public_path__ + "static/media/blog-34-image-4.1943719a.jpg";